import { Controller } from "@hotwired/stimulus"

/* przykład użycia: app/views/design/uix/stimulus.html.erb */

export default class extends Controller {
  connect() {
    // zapamiętywanie i odzyskiwanie scrolla na odpowiedniej wysokości
    // zasada działania: pamiętamy na raz max jeden typ danej strony (np.: index maili) [na podstawie request.path]
    // więc jeśli jesteśmy na inboxie i przejdziemy na zarchiwizowane maile, to scroll na inboxie jest zapomniany
    // za to jeśli z inboxu wejdziemy w pojedynczy email, a potem wrócimy to scroll zostanie wczytany poprawnie
    // WAŻNE: zapamiętujemy położenia w obrębie pojedynczej sesji, więc zamknięcie karty w przeglądarce resetuje zapamiętane scrolle
    addEventListener("turbo:before-render", function () {
      document.querySelectorAll("[data-remember-position]").forEach(function (element) {
        sessionStorage.setItem("scrollPosition_position_" + element.id, element.scrollTop)
        sessionStorage.setItem("scrollPosition_page_" + element.id, element.dataset.url)
      })
    })

    addEventListener("turbo:render", function () {
      document.querySelectorAll("[data-remember-position]").forEach(function (element) {
        if (sessionStorage.getItem("scrollPosition_page_" + element.id) === element.dataset.url) {
          element.scrollTop = sessionStorage.getItem("scrollPosition_position_" + element.id)
        }
      })
    })

    // zmiana tytułu strony jeśli został podany za pomocą turbo_stream.update("page_title", plain: page_title)
    addEventListener("turbo:before-stream-render", (event) => {
      const streamElement = event.target
      if (streamElement.action === "update" && streamElement.getAttribute("target") === "page_title") {
        const newTitle = streamElement.templateContent.textContent.trim()
        document.title = newTitle
        event.preventDefault()
      }
    })

    // Stara wersja zapamiętywania scrolla - chyba nie działała, lub przestała działać w pewnym momencie
    // ustawienie pozycji scrolla na odpowiedniej wysokości
    // if (!this.isMobileVariant) {
    //   var pathName = document.location.pathname
    //   window.onpagehide = function () {
    //     var scrollPosition = document.querySelector('main').scrollTop
    //     sessionStorage.setItem("scrollPosition_" + pathName, scrollPosition)
    //   }
    //   if (window.performance && window.performance.getEntriesByType("navigation")[0].type === "back_forward") {
    //     if (sessionStorage["scrollPosition_" + pathName]) {
    //       document.querySelector('main').scrollTop = sessionStorage.getItem("scrollPosition_" + pathName)
    //     }
    //   }
    // }
  }

  get isMobileVariant() {
    return document.head.querySelector("meta[name=app_variant]").content === "mobile"
  }

  disconnect() {
  }
}
